//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getAllSelectedContent } from './getAllSelectedContent';

export const getNumSelectedImages = createSelector(
  getAllSelectedContent,
  (selectedImages) => selectedImages.length,
);
